import type { IconData } from '@stacksjs/iconify-core'

export const medicalCross: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M344 16H168v152H16v176h152v152h176V344h152V168H344Zm120 184v112H312v152H200V312H48V200h152V48h112v152Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default medicalCross
